import Accessibility from 'highcharts/modules/accessibility';

declare var require: any;
import Highcharts from 'highcharts';
import Boost from 'highcharts/modules/boost';
import NoData from 'highcharts/modules/no-data-to-display';
import More from 'highcharts/highcharts-more';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';
import { SharedDataService } from '../services/shared-data.service';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

Boost(Highcharts);
NoData(Highcharts);
More(Highcharts);
Accessibility(Highcharts);

@Component({
  selector: 'app-chart-institucion',
  standalone: true,
  imports: [MaterialModule, CommonModule],
  templateUrl: './chart-institucion.component.html',
  styleUrl: './chart-institucion.component.less'
})
export class ChartInstitucionComponent implements AfterViewInit, OnInit {
  @Input() title!: string;
  @Input() subtitle!: string;

  chartData: { name: string, y: number }[] = [];
  options: any = {
    colors: [
      '#000467',
      '#a5abd6',
    ],
    chart: { type: 'bar',
      style: {
        fontFamily: 'DM Sans',
      },
    },
    credits: {
      enabled: false
    },
    title: { text: 'Institución' },
    subtitle: {
      text: 'Tasa (anual)*',
      align: 'center', 
    },
    xAxis: { 
      categories: [],
      gridLineWidth: 0,
    },
    yAxis: {
      visible: false,
    },
    plotOptions: {
      series: {
        enableMouseTracking: false,
        dataLabels: {
          enabled: true,
          format: '{y:.2f}%',
          inside: true,
          align: 'right',
          x: -10,
          style: {
            color: 'white',
            textOutline: false,
            textShadow: '0px 0px 6px black',
          },
        },
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.y:.2f}%</b>',
      enabled: false,
    },
    series: [
      {
        name: '',
        data: [],
      },
    ],
  };

  constructor(private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    this.sharedDataService.chartInstitucionData$.subscribe(data => {
      if (data) {
        this.processChartData(data);
      }
    });
  }

  ngAfterViewInit() {
    this.updateChart();
  }

  processChartData(chartData: any): void {
    if (chartData && chartData.success && chartData.data) {
      this.chartData = Object.keys(chartData.data).map(key => ({
        name: key,
        y: parseFloat(chartData.data[key]),
      }));

      this.options.xAxis.categories = Object.keys(chartData.data);
    } else {
      this.chartData = [
        { name: 'Simpli', y: 0 },
        { name: 'Btg', y: 0 },
        { name: 'Internacional', y: 0 },
        { name: 'Consorcio', y: 0 },
        { name: 'Estado', y: 0 },
      ];
      this.options.xAxis.categories = ['Simpli', 'Btg', 'Internacional', 'Consorcio', 'Estado'];
    }
    this.updateChart();
  }

  updateChart(): void {
    if (this.options && this.chartData) {
      this.options.series = [
        {
          name: 'Tasa',
          data: this.chartData.map(item => ({
            name: item.name,
            y: item.y,
            color: item.name === 'Simpli' ? '#000467' : '#a5abd6',
          })),
        },
      ];
      Highcharts.chart('containerInst', this.options);
    }
  }
}
